import {
	PutObjectCommand,
	S3Client,
	S3ServiceException,
} from "@aws-sdk/client-s3";
import { getFileBuffer } from "../utils/file";

// EXAMPLE: Init Backup Cloud Response
// {
//     "backupId": "4",
//     "backupExternalId": "136ae56c-31d9-43bd-a47e-462a624165e2",
//     "allow": true,
//     "remainingSpace": null,
//     "storage": "s3",
//     "bucketName": "prd0028-backups",
//     "bucketObjectKey": "13-organization/123456n-sn/1755800970237_backup.zip",
//     "credentials": {
//         "tempAccessToken": "",
//         "tempAccessKey": "",
//         "tempSecretAccessKey": "",
//         "expiration": "2025-08-21T22:29:30.000Z"
//     },
//     "serialNumber": "123456n"
// }

export class S3Service {
	static async putObject(credentials, bucketName, bucketKey, file) {
		const client = new S3Client({
			credentials: {
				accessKeyId: credentials.tempAccessKey,
				secretAccessKey: credentials.tempSecretAccessKey,
				sessionToken: credentials.tempAccessToken,
			},
			region: credentials.region,
		});
		const fileBuffer = await getFileBuffer(file);
		const command = new PutObjectCommand({
			Bucket: bucketName,
			Key: bucketKey,
			Body: fileBuffer,
		});
		try {
			const response = await client.send(command);
		} catch (caught) {
			if (
				caught instanceof S3ServiceException &&
				caught.name === "EntityTooLarge"
			) {
				console.error(
					`Error from S3 while uploading object to ${bucketName}. \
	  The object was too large. To upload objects larger than 5GB, use the S3 console (160GB max) \
	  or the multipart upload API (5TB max).`,
				);
			} else if (caught instanceof S3ServiceException) {
				console.error(
					`Error from S3 while uploading object to ${bucketName}.  ${caught.name}: ${caught.message}`,
				);
			} else {
				throw caught;
			}
		}
	}
}